import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="wrapper">
            <Header />
            <main className="main-content pt-20 md:pt-24">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;